var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedCount)?_c('div',{staticClass:"faixa-comparacao"},[_c('span',{staticClass:"text-lg"},[_vm._v("\n    "+_vm._s(_vm.selectedCount === 1
        ? 'Selecione ao menos 2 dados para comparação'
        : (_vm.selectedCount + " dados selecionados"))+"\n  ")]),_vm._v(" "),(_vm.selectedCount > 1)?_c('router-link',{staticClass:"btn btn-default",attrs:{"title":"Comparar Dados","to":{
      name: 'public_comparar',
      params: { ids: _vm.idsArray.join(',') }, 
      query: { origem: _vm.query }     
    }}},[_vm._v("\n    Comparar "+_vm._s(_vm.selectedCount)+" dados\n  ")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d63ff3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dados/FaixaComparacao.vue
// module id = x/tY
// module chunks = 15